<template>
    <el-container style="width: 100%;height: 100%;">
        <!-- <el-header style="background-color: #ffffff;display: flex;flex-direction: row;">
            <div class="p2pMiddle" style="margin-left: 10px;">
                <el-button 
                        type="danger"
                        icon="el-icon-turn-off-microphone"
                        :loading="callBtnLoading"
                        @click="handup">{{ callBtnText }}
                </el-button>
            </div>
        </el-header> -->
        <el-main style="background-color: #000000;overflow: hidden;position: relative;min-height: 500px;height: 100%;">
            <!-- 视频画面 -->
            <video id="remoteVideo" playsinline autoplay style="cursor: pointer;width: 100%;height: 100%;" v-show="showVideo && connectionState === 'connected'"></video>
            
            <!-- 音频对讲界面 -->
            <div class="content-container" v-show="!showVideo">
                <div class="audio-indicator" :class="{'pulse': connectionState === 'connected'}">
                    <i class="el-icon-microphone" style="color: #ffffff;font-size: 180px;"></i>
                </div>
                <div class="status-text">{{ statusText }}</div>
            </div>

            <!-- 视频加载状态 -->
            <div class="video-loading" v-show="showVideo && connectionState !== 'connected'">
                <div class="loading-content">
                    <i class="el-icon-loading" style="font-size: 60px;color: #409EFF;margin-bottom: 20px;"></i>
                    <div class="status-text">{{ statusText }}</div>
                </div>
            </div>

            <!-- 连接状态指示器 - 移到底部中央 -->
            <div class="connection-status" v-if="connectionState === 'connected'">
                <div class="status-dot"></div>
                <span>{{ mediaType === 0 ? '对讲中' : mediaType === 1 ? '视频中' : '音视频中' }}</span>
            </div>

            <!-- 二次确认按钮 -->
            <el-button type="danger" style="position: absolute;top:80px;right: 40px;" :loading="secondCheckLoading" @click="secondCheckClick" v-if="showSecondCheckBtn">{{ secondCheckBtnText }}</el-button>
        </el-main>
    </el-container>
</template>
<script>
// import { Player } from '@/utils/executor';
import mqtt from 'mqtt';
export default {
    props:{
        mediaType: {
            typeof: Number,
            default() {
                return 2
            }
        },
        SecondCheck: {
            typeof: Boolean,
            default() {
                return false
            }
        }
    },
    components: { 
        
    },
    data() {
        return {
            secondCheckLoading:false,
            secondCheckBtnText:"接听",
            showSecondCheckBtn:false,
            showVideo:true,
            peerId:"ice00041",
            localId:"",
            localStream:null,
            localDesc:null,
            signalChannel:"mqtt",
            client:null,
            pc1:null,
            candidates:'',
            // 只保留该 IP 的 SDP 信息，过滤掉其他所有 IP（含浏览器自身 IPv4）
            targetP2pIp: '47.112.176.126',
            dcCommand:null,
            dcData:null,
            offerOptions:{
                offerToReceiveAudio: 1,
                offerToReceiveVideo: 1    
            },
            startTime:"",
            connectionState: 'new', // 连接状态: new, connecting, connected, disconnected, failed
            statusText: '初始化中...', // 状态文本
            sdpConfig:{
                rtcConfiguration: {
                    audioJitterBufferMaxPackets: 20,  // 默认 50，建议 10-30
                    audioJitterBufferFastAccelerate: true, // 加速追赶延迟
                },
                // 与 demo 对齐：IPv4 直连 TURN，同时申请 UDP+TCP relay（UDP 优先，TCP 兜底）；仅使用 relay
                iceServers:
                    [
                        {urls:["turn:47.112.176.126?transport=udp"],username:"qxiot",credential:"123456"},
                        {urls:["turn:47.112.176.126?transport=tcp"],username:"qxiot",credential:"123456"}
                    ],
                    iceTransportPolicy:"relay",
                    iceCandidatePoolSize: 0    // 减少无效候选
                },
            remoteVideo:null, 
            callBtnText:"呼叫中...",
            callBtnLoading:true,
            instance: null,
            mediaRecorder:null,
            recordedChunks:[],

            // ---- lifecycle/cleanup guards ----
            isClosed: false,
            hasStartedCall: false,
            offerTimer: null,
            answerTimer: null,
            byeEndTimer: null,
            mqttHandlers: null,
            lastDiagnostic: "",
            gotAnswer: false,
        }
    },
    beforeDestroy(){
        // 组件关闭/销毁时必须彻底清理，否则 MQTT/定时器仍会继续触发 publish
        // 只要已经发起过呼叫（哪怕还没 connected），关闭弹窗也要给设备发 bye
        this.cleanup({ sendBye: this.isTalking || this.hasStartedCall });
        // this.mediaRecorder.stop();
    },
    async mounted() {

        this.localId = Date.now() + ""
        this.remoteVideo = document.getElementById('remoteVideo');
        // 动态生成peerID
        this.peerId = Date.now()
        switch(this.mediaType){
            case 0:
                this.offerOptions.offerToReceiveAudio = 1
                this.offerOptions.offerToReceiveVideo = 0
                this.showVideo = false
                break;
            case 1:
                this.offerOptions.offerToReceiveAudio = 0
                this.offerOptions.offerToReceiveVideo = 1
                break;
            case 2:
                this.offerOptions.offerToReceiveAudio = 1
                this.offerOptions.offerToReceiveVideo = 1
                break;
        }
        
        // 需要二次确认，并且只有对讲
        if(this.SecondCheck && this.mediaType == 0){
            this.showSecondCheckBtn = true
            this.statusText = '等待接听...'
            return
        }

        if(this.SecondCheck && this.mediaType == 2){
            this.showSecondCheckBtn = true
            this.offerOptions.offerToReceiveAudio = 0
            this.statusText = '等待接听...'
        }

        await this.getMediaDevices()

        this.statusText = '正在连接...'
        this.connectionState = 'connecting'

        await this.connectSignalChannel()
    },
    methods: {
        /**
         * 等待 TURN relay：有 UDP 立即结束；仅有 TCP 时短等 UDP，避免 UDP 黑洞拖满 20s
         */
        waitForGathering(pc) {
            return new Promise((resolve, reject) => {
                let settled = false;
                let earlyTimer = null;
                const sdp = () => (pc.localDescription && pc.localDescription.sdp) || "";
                const hasRelay = () => / typ relay(?: |\r?$)/m.test(sdp());
                const hasUdpRelay = () => / udp .+ typ relay(?: |\r?$)/im.test(sdp());
                const finish = (error) => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timer);
                    clearTimeout(earlyTimer);
                    pc.removeEventListener("icegatheringstatechange", check);
                    pc.removeEventListener("signalingstatechange", check);
                    pc.removeEventListener("icecandidate", check);
                    error ? reject(error) : resolve();
                };
                const check = () => {
                    if (pc.signalingState === "closed") {
                        finish(new Error("连接已关闭"));
                        return;
                    }
                    if (pc.iceGatheringState === "complete") {
                        finish();
                        return;
                    }
                    // UDP relay 优先，到手即发 offer，不必等 TCP/黑洞超时
                    if (hasUdpRelay()) {
                        console.log("已获得 UDP TURN relay，提前结束候选收集");
                        finish();
                        return;
                    }
                    // 仅 TCP：再等一小段给 UDP，避免黑洞 UDP 拖到 20s
                    if (hasRelay() && !earlyTimer) {
                        earlyTimer = setTimeout(() => {
                            if (hasRelay()) {
                                console.log("UDP 未及时到达，使用已获得的 TURN relay（可能为 TCP）");
                                finish();
                            }
                        }, 2500);
                    }
                };
                const timer = setTimeout(() => {
                    if (hasRelay()) {
                        console.log("候选收集达到时限，使用已获得的 TURN relay");
                        finish();
                    } else {
                        finish(new Error("TURN 候选收集超时，未获得可用 relay"));
                    }
                }, 20000);
                pc.addEventListener("icegatheringstatechange", check);
                pc.addEventListener("signalingstatechange", check);
                pc.addEventListener("icecandidate", check);
                check();
            });
        },
        cleanup({ sendBye = false } = {}){
            this.isClosed = true;

            if (this.offerTimer) {
                clearTimeout(this.offerTimer);
                this.offerTimer = null;
            }
            if (this.answerTimer) {
                clearTimeout(this.answerTimer);
                this.answerTimer = null;
            }
            if (this.byeEndTimer) {
                clearTimeout(this.byeEndTimer);
                this.byeEndTimer = null;
            }

            // 停止本地媒体
            try {
                if (this.localStream && this.localStream.getTracks) {
                    this.localStream.getTracks().forEach(t => {
                        try { t.stop(); } catch (e) { /* ignore */ }
                    });
                }
            } catch (e) { /* ignore */ }
            this.localStream = null;

            // 清理 video 绑定
            try {
                if (this.remoteVideo) {
                    this.remoteVideo.srcObject = null;
                    this.remoteVideo.load && this.remoteVideo.load();
                }
            } catch (e) { /* ignore */ }

            // 关闭 DataChannel / PeerConnection
            try { if (this.dcCommand) this.dcCommand.close(); } catch (e) { /* ignore */ }
            try { if (this.dcData) this.dcData.close(); } catch (e) { /* ignore */ }
            this.dcCommand = null;
            this.dcData = null;

            try {
                if (this.pc1) {
                    // 解绑回调，避免关闭后仍触发回调写状态/发消息
                    this.pc1.onicecandidate = null;
                    this.pc1.onicegatheringstatechange = null;
                    this.pc1.onicecandidateerror = null;
                    this.pc1.onconnectionstatechange = null;
                    this.pc1.ontrack = null;
                    this.pc1.close();
                }
            } catch (e) { /* ignore */ }
            this.pc1 = null;

            // 断开 MQTT（关键：否则 mqtt.js 会自动重连并触发 connect/message 回调）
            try {
                if (this.client) {
                    const client = this.client;
                    const handlers = this.mqttHandlers;

                    const unbind = () => {
                        try {
                            if (handlers) {
                                try { client.off('connect', handlers.onConnect); } catch (e) { /* ignore */ }
                                try { client.off('message', handlers.onMessage); } catch (e) { /* ignore */ }
                                try { client.off('reconnect', handlers.onReconnect); } catch (e) { /* ignore */ }
                                try { client.off('error', handlers.onError); } catch (e) { /* ignore */ }
                            } else {
                                try { client.removeAllListeners(); } catch (e) { /* ignore */ }
                            }
                        } catch (e) { /* ignore */ }
                    };

                    const endNow = () => {
                        // force=true 会立即断开；因此必须保证 bye 已经发送（或超时兜底）后再调用
                        try { client.end(true); } catch (e) { /* ignore */ }
                    };

                    // 先置空引用，避免后续逻辑误用；实际断开由 endNow 控制
                    this.client = null;
                    this.mqttHandlers = null;

                    if (sendBye && this.signalChannel === "mqtt") {
                        // 优先使用设备编号作为 peerId，避免还没覆盖 this.peerId 时发到错误 topic
                        const peerId = (this.mqttData && this.mqttData.device_number) ? this.mqttData.device_number : this.peerId;
                        try {
                            client.publish(
                                "webrtc_ctl/" + peerId,
                                JSON.stringify({ cmd: "bye" }),
                                { qos: 1 },
                                () => {
                                    unbind();
                                    endNow();
                                }
                            );
                            // 兜底：如果回调没触发（例如网络问题），最多等待 800ms 仍强制关闭
                            this.byeEndTimer = setTimeout(() => {
                                unbind();
                                endNow();
                                this.byeEndTimer = null;
                            }, 800);
                        } catch (e) {
                            unbind();
                            endNow();
                        }
                    } else {
                        unbind();
                        endNow();
                    }
                }
            } catch (e) { /* ignore */ }

            this.mqttHandlers = null;

            this.isTalking = false;
            this.connectionState = 'disconnected';
        },
        async secondCheckClick(){
            this.secondCheckLoading = true
            this.secondCheckBtnText = "连接中..."
            this.statusText = '正在连接...'
            this.connectionState = 'connecting'
            this.$emit("secondCheckFun")

            if(this.mediaType == 0){
                await this.getMediaDevices()
                this.connectSignalChannel()
                return
            }

            if(this.mediaType == 2){
                await this.handup()
                this.offerOptions.offerToReceiveAudio = 1
                this.statusText = '正在请求音频...'
                this.callPeer()
            }
        },
        async callPeer(){
            if (this.isClosed) return;
            this.startTime = window.performance.now();
            this.statusText = this.mediaType === 0 ? '正在建立语音连接...' : this.mediaType === 1 ? '正在建立视频连接...' : '正在建立音视频连接...'
            await this.createPC("offer",null);

            this.hasStartedCall = true;
            this.gotAnswer = false;

            try {
                await this.waitForGathering(this.pc1);
            } catch (e) {
                console.log("ICE 收集失败:", e.message || e);
                this.statusText = '连接失败: ' + (e.message || '未知错误');
                return;
            }

            if (this.isClosed || !this.client) return;

            // createOffer 时的 localDesc 不含后续 ICE 候选，需与浏览器最新 SDP 对齐
            if (this.pc1 && this.pc1.localDescription) {
                const peer = (this.localDesc && this.localDesc.peer) || this.localId;
                this.localDesc = {
                    type: this.pc1.localDescription.type,
                    sdp: this.pc1.localDescription.sdp,
                    peer
                };
            }

            this.localDesc.sdp = this.localDesc.sdp
                    .replace(/a=rtcp-fb.*?\r?\n/g,"")
                    .replace(/a=fmtp.*?\r?\n/g,"")
                    .replace(/a=extmap.*?\r?\n/g,"")
                    .replace(/^a=rtpmap:(?!.*H264).*\r?\n/gm,"");
            
            this.localDesc.sdp = this.filterSdpByTargetIp(this.localDesc.sdp);
            this.localDesc.sdp += this.candidates;
            this.localDesc.sdp = this.filterSdpByTargetIp(this.localDesc.sdp);

            const candidates = this.localDesc.sdp.split(/\r?\n/).filter(line => line.startsWith("a=candidate:"));
            const hasRelay = candidates.some(line => / typ relay(?: |$)/.test(line));
            if (!hasRelay) {
                console.log("警告：未获得 TURN relay 候选，将尝试使用其他候选类型");
            }
            
            var msg = {
                'peer':this.localDesc.peer,
                'sdp':this.localDesc.sdp,
                'type':this.localDesc.type
            }
            if (this.signalChannel == "mqtt"){
                this.client.publish("ice_offer/" +  this.peerId , JSON.stringify(msg))
                this.statusText = '等待对方响应...'
            }

            if (this.answerTimer) clearTimeout(this.answerTimer);
            this.answerTimer = setTimeout(() =>{
                if (this.isClosed || this.gotAnswer) return;
                console.log("等待设备 answer 超过 35 秒。",
                    this.lastDiagnostic ? "最后设备诊断: " + this.lastDiagnostic :
                    "未收到设备诊断：请检查设备在线状态、诊断版固件及 MQTT 消息投递/主题权限。");
            }, 35000);
        },
        /**
         * 只保留 targetP2pIp 的 SDP 信息，过滤掉其他所有 IP（含 IPv6 及浏览器自身 IPv4）
         * 被删掉的 c= 行用 target IP 补回，保证每个 media 段都有有效 c=，避免对端建连失败
         */
        filterSdpByTargetIp(sdp) {
            const target = this.targetP2pIp || '47.112.176.126';
            sdp = sdp.replace(/a=candidate:[^\r\n]*\r?\n/gi, (line) => line.includes(target) ? line : '');
            sdp = sdp.replace(/^c=IN IP[46] [^\r\n]*\r?\n/gm, (line) => line.includes(target) ? line : `c=IN IP4 ${target}\r\n`);
            sdp = sdp.replace(/^[a-z]=[^\r\n]*\[?([0-9a-fA-F]{1,4}:){4,}[0-9a-fA-F]{1,4}\]?[^\r\n]*\r?\n/gim, '');
            return sdp;
        },
        handup(){
            // 主动挂断（不等同于关闭弹窗/销毁组件）：关闭 RTC，发 bye，但保留 MQTT 连接以便继续流程（如二次确认）
            if (this.offerTimer) {
                clearTimeout(this.offerTimer);
                this.offerTimer = null;
            }
            if (this.answerTimer) {
                clearTimeout(this.answerTimer);
                this.answerTimer = null;
            }

            try { if (this.dcCommand) this.dcCommand.close(); } catch (e) { /* ignore */ }
            try { if (this.dcData) this.dcData.close(); } catch (e) { /* ignore */ }
            this.dcCommand = null;
            this.dcData = null;

            try {
                if (this.pc1) {
                    this.pc1.onicecandidate = null;
                    this.pc1.onicegatheringstatechange = null;
                    this.pc1.onicecandidateerror = null;
                    this.pc1.onconnectionstatechange = null;
                    this.pc1.ontrack = null;
                    this.pc1.close();
                }
            } catch (e) { /* ignore */ }
            this.pc1 = null;

            this.isTalking = false
            this.connectionState = 'disconnected'
            this.statusText = '已断开连接'

            if(this.signalChannel == "mqtt" && this.client){
                try {
                    this.client.publish("webrtc_ctl/" + this.peerId , JSON.stringify({ cmd: "bye" }))
                } catch (e) { /* ignore */ }
            }else{
                console.log("websocket")
            }
        },
        async getMediaDevices(){
            try{
                // 检查浏览器是否支持 getUserMedia
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    console.error('浏览器不支持 getUserMedia API，请使用 HTTPS 协议或更新浏览器');
                    this.$message.warning('当前环境不支持音频功能，请使用 HTTPS 协议访问');
                    return;
                }
                
                // 先请求媒体访问权限
                const stream = await navigator.mediaDevices.getUserMedia({  
                    audio: true,
                    video: false // 根据需求调整 
                });
                this.localStream = stream
            } catch (error){
                console.error('Error enumerating devices:', error);
                this.$message.error('获取音频设备失败：' + error.message);
            }
        },
        connectSignalChannel(){
            if(this.signalChannel == "mqtt"){
                this.mqttConnect();
                
            }else{
                this.websockConnect()
            }
        },
        mqttConnect(){
            let connection = {
                host: 'mqtt.tranthing.com',
                port: 9001,
                path: '/',
                user: { username: "qxwladmin", password: "@QmXqWtLt22%$" },
            }

            return new Promise(resolve => {
                // 重新连接前先彻底释放旧连接
                if (this.client) {
                    try { this.client.end(true); } catch (e) { /* ignore */ }
                    this.client = null;
                }

                // mqtt.js 默认会自动重连；我们用 guard 避免重复 callPeer
                this.client = mqtt.connect(
                    "wss://" + connection.host + ':' + connection.port + connection.path,
                    { ...connection.user }
                )


                const onConnect = () => {
                    if (this.isClosed) return;
                    if(!this.client) return;

                    this.peerId = this.mqttData.device_number

                    // 订阅自身 peer 的 answer/offer（统一用带 / 的主题）
                    this.client.subscribe("ice_answer/"+this.localId, () => { /* noop */ });
                    // 项目内其它 P2P 实现使用 "ice_offer"+localId（无 /），这里保持一致
                    this.client.subscribe("ice_offer"+this.localId, () => { /* noop */ });
                    this.client.subscribe("TranthingCamera/oneClickAlarm", () => { /* noop */ });
                    this.client.subscribe("ice_diag/"+this.localId, () => { /* noop */ });

                    resolve();

                    // 连接成功后开始呼叫
                    if (!this.hasStartedCall) {
                        this.callPeer()
                    }

                };

                // 订阅成功之后接收mqtt的信息
                const onMessage = (topic, message) => {
                    if (this.isClosed) return;
                    console.log(topic+": "+message)
                    if (topic === "ice_diag/"+this.localId) {
                        this.lastDiagnostic = message;
                        console.log("设备诊断:", message);
                        return;
                    }
                    if(topic.search("ice_answer") != -1 || topic.search("ice_offer") != -1 ){
                        this.onRemoteSDP(message)
                    }
                };

                const onReconnect = () => {
                    // 不在这里做任何业务动作；connect 里用 guard 控制 callPeer
                    return
                };
                const onError = () => { /* noop */ };

                this.mqttHandlers = { onConnect, onMessage, onReconnect, onError };

                this.client.on('connect', onConnect)
                this.client.on("message", onMessage);
                this.client.on("reconnect", onReconnect)
                this.client.on('error', onError);
            })
        },
        websockConnect(){

        },
        async onRemoteSDP(sdp){
            if (this.isClosed) return;
            const desc = JSON.parse(sdp);
            const cands = desc.sdp.match(/a=(candidate:[^\r\n]+)/g);

            //收到offer
            if (desc.type === 'offer'){
                await this.createPC("answer",desc);

                if (this.answerTimer) clearTimeout(this.answerTimer);
                this.answerTimer = setTimeout(() =>{
                    if (this.isClosed) return;
                    if (!this.client) return;
                    this.localDesc.sdp += this.candidates;
                    this.localDesc.sdp = this.filterSdpByTargetIp(this.localDesc.sdp);
                    this.client.publish("ice_answer/" + this.peerId,JSON.stringify(this.localDesc));
                },1000);
            }

            //收到answer
            if (desc.type === 'answer'){
                await this.pc1.setRemoteDescription(desc);
                this.gotAnswer = true;
                if (this.answerTimer) {
                    clearTimeout(this.answerTimer);
                    this.answerTimer = null;
                }
            }

            if (cands){
                cands.forEach(async can=>{
                // addIceCandidate 需要 "candidate:..." 格式，match 可能带回 "a=" 前缀，需去掉
                const candidateStr = String(can).replace(/^\s*a=/, '').trim();
                if (!candidateStr) return;
                await this.pc1.addIceCandidate({
                    type:'candidate',
                    candidate: candidateStr,
                    sdpMid: "0",
                    sdpMLineIndex: 0
                });
                });
            }
        },
        async createPC(descType,desc){
            try {
                this.pc1 = new RTCPeerConnection(this.sdpConfig);
                // console.log('Created local peer connection object pc1');
                this.candidates = '';
                // 绑定 this，避免回调里的 this 指向 RTCPeerConnection
                this.pc1.onicecandidate =  this.onIceCandidate.bind(this);
                this.pc1.onicegatheringstatechange = this.onIceStateChange.bind(this);
                this.pc1.onicecandidateerror = this.onAddIceCandidateError.bind(this);
                this.pc1.onconnectionstatechange = this.onConnectionStateChange.bind(this);
                this.pc1.ontrack = this.onTrack.bind(this);

                this.dcCommand = this.pc1.createDataChannel("dcCommand",{negotiated: true,id:0}); //,{
                //       negotiated: true,
                //       id: 0,
                //       ordered: false, // 无序传输
                //       maxRetransmits: 0 // 不重传
                //     });

                

                this.dcCommand.onopen = (evt)=>{
                    console.log(evt);
                };

                this.dcCommand.onclose = (evt)=>{
                    console.log(evt);
                };

                this.dcCommand.onmessage = (event) => {
                    console.log(`dcCommand: ${event.data}`);
                };

                this.dcData = this.pc1.createDataChannel("dcData",{negotiated: true,id:1});

                this.dcData.onopen = (evt)=>{
                    console.log(evt)
                };

                this.dcData.onclose = (evt)=>{
                    console.log(evt)
                };
                this.dcData.onmessage = (event) => {
                    console.log(`dcData: ${event.data}`);
                };

                if (this.localStream != null ){
                    console.log('Added local stream to pc1');
                    console.log('this.localStream',this.localStream);
                    console.log('this.localStream',this.localStream.getTracks());
                    if(this.SecondCheck){
                        if(this.secondCheckLoading){
                            this.localStream.getTracks().forEach(track => this.pc1.addTrack(track, this.localStream));
                        }
                    }else{
                        this.localStream.getTracks().forEach(track => this.pc1.addTrack(track, this.localStream));
                    }
                }
                console.log('pc1 createOffer start');
                if (descType === "offer"){
                    this.localDesc = await this.pc1.createOffer(this.offerOptions);
                }else{
                if (desc){
                    await this.pc1.setRemoteDescription(desc);
                }
                this.localDesc = await this.pc1.createAnswer(this.offerOptions);
                }
                await this.pc1.setLocalDescription(this.localDesc);

                this.localDesc.peer = this.localId;
                
                console.log(this.localDesc);
                // await onCreateOfferSuccess(offer);
            } catch (e) {
                console.log(e);
                // onCreateSessionDescriptionError(e);
            }
        },
        async onIceCandidate(event){
            if (event && event.type === 'icecandidate' && event.candidate){
                if (this.candidates.indexOf(event.candidate.candidate) == -1){
                    if (event.candidate.candidate.indexOf('.local') == -1){
                        // 只根据 candidate 第 5 段地址判断 IPv6，避免宽松正则误伤
                        const candidateStr = event.candidate.candidate;
                        const addr = (candidateStr.split(' ')[4] || '');
                        const isIPv6 = addr.includes(':');
                        if (!isIPv6) {
                            this.candidates += "a="+event.candidate.candidate+"\n";
                        }
                    }
                }
            }
        },
        onIceStateChange(event){
            console.log('ICE state change event: ');
            console.log( event);
        },
        onAddIceCandidateError(error){
            console.log(`failed to add ICE Candidate: ${error.toString()}`);
            console.log(error);
        },
        onConnectionStateChange(event){
            console.log("connection event",event);
            console.log(this.pc1.connectionState);
            
            // 更新连接状态
            this.connectionState = this.pc1.connectionState;
            
            if(this.pc1.connectionState == "connected"){
                this.callBtnLoading = false
                this.callBtnText = "挂断"
                this.isTalking = true
                
                // 根据媒体类型设置状态文本
                if(this.mediaType === 0){
                    this.statusText = '语音对讲中'
                } else if(this.mediaType === 1){
                    this.statusText = '视频通话中'
                } else {
                    this.statusText = '音视频通话中'
                }

                if(this.secondCheckLoading){
                    this.showSecondCheckBtn = false
                    this.secondCheckLoading = false
                    this.secondCheckBtnText = "接听"
                }

                // this.initMediaRecorder()
                
            } else if(this.pc1.connectionState == "connecting"){
                this.statusText = '正在连接...'
            } else if(this.pc1.connectionState == "disconnected"){
                this.statusText = '连接已断开'
            } else if(this.pc1.connectionState == "failed"){
                this.statusText = '连接失败，请重试'
                this.$message.error('连接失败，请检查网络或重试');
            }
        },
        onTrack(event){
            // console.log('onTrack');
            // console.log(event);
            if (this.remoteVideo) {
                this.remoteVideo.srcObject = event.streams[0];
            }
        },
        initMediaRecorder(){
            let stream = this.pc1.getRemoteStreams()[0]
            this.mediaRecorder = new MediaRecorder(stream);
            this.recordedChunks = [];

            this.mediaRecorder.ondataavailable = (evt) => {
                if(evt.data.size > 0){
                    this.recordedChunks.push(event.data);
                }
            }

            this.mediaRecorder.onstop = () => {
                const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'recorded-video.webm';
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(url);
            }

            this.mediaRecorder.start();
        }
                
    },
    computed: {
        mqttData() {
            return this.$store.state.mqttData
        },
    }

}
</script>

<style lang="scss" scoped>
.videoContro-box{
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    padding: 20px 10px;
}

.p2pMiddle{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

// 内容容器 - 确保有固定高度
.content-container {
    width: 100%;
    min-height: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

// 音频指示器
.audio-indicator {
    transition: all 0.3s ease;
    
    &.pulse {
        animation: pulse 2s infinite;
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
}

// 状态文本
.status-text {
    color: #ffffff;
    font-size: 24px;
    font-weight: 500;
    margin-top: 30px;
    text-align: center;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

// 视频加载状态
.video-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 500px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 10;
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

// 连接状态指示器 - 移到底部中央
.connection-status {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    padding: 10px 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 25px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    backdrop-filter: blur(8px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.4s ease;
    z-index: 100;
}

@keyframes slideUp {
    from {
        transform: translateX(-50%) translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateX(-50%) translateY(0);
        opacity: 1;
    }
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #67C23A;
    margin-right: 8px;
    animation: blink 2s infinite;
}

@keyframes blink {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
}
</style>